import { render, staticRenderFns } from "./PRO_ByFacility.vue?vue&type=template&id=2cc50190&scoped=true&"
import script from "./PRO_ByFacility.vue?vue&type=script&lang=js&"
export * from "./PRO_ByFacility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc50190",
  null
  
)

export default component.exports